// extracted by mini-css-extract-plugin
export default {"button":"styles_button__XI61z","icon":"styles_icon__FER4g","update":"styles_update__ejPfy"};